export default __webpack_public_path__ + "static/media/eye-green-icon.3cb9a6ab.svg";